module.exports = __webpack_public_path__ + "img/newFa.4fc58155.png";